<template>
  <loading v-if="isProfileFetching" />
  <profile-details v-else />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '@/app/components/Loading';
import ProfileDetails from '@/app/components/profile/ProfileDetails';

export default {
  name: 'DetailsView',
  components: {
    Loading,
    ProfileDetails
  },
  computed: {
    ...mapGetters('app', [
      'isProfileFetching'
    ])
  },
  async created() {
    await this.fetchProfile();
  },
  methods: {
    ...mapActions('app', [
      'fetchProfile'
    ])
  }
};
</script>
